import View from "./View.vue"
import { mergeAttributes } from "@tiptap/vue-3"
import DynamicNode from '../Dynamic.js'

export default DynamicNode({
  name: 'Auctions',

  group: 'block',

  content: 'block',

  isolating: true,

  allowGapCursor: true,

  draggable: true,

  renderHTML({ HTMLAttributes }) {
    return [this.options.schema.tag, mergeAttributes(HTMLAttributes), 0]
  },
}, View)
